import React from 'react'
import logo from "../components/logo.png";
import {Link} from "react-router-dom";
function Navbar() {
  return (
    <div className=' flex pl-12 space-x-8 items-center py-1 bg-stone-900 bg-opacity-90'>
     <img src={logo} className='h-[50px] md:h-[60px]' ></img >
     <Link to="/" className='text-black-600 font-bold text-xl hover:text-yellow-400 md:text-3xl'>Movies</Link>
     <Link to="/Favourites" className='text-black-600 font-bold hover:text-yellow-400 text-xl md:text-3xl'>Favourites</Link>


    </div>
  )
}

export default Navbar